import { authAxios } from '@/extra-functions/axios.extra'

/**
 * @typedef {Object} ConsumerLoanIndexParams
 * @property {string|null} search
 * @property {number} limit
 */
/**
 * Description
 * @param {ConsumerLoanIndexParams} params
 */
export const getIndex = (params) => {
  return authAxios().get('/v2/consumer-loans', { params })
}

/**
 * Description
 * @param {number} id
 * @param {'return-receipt'|'unreturn-receipt'} action
 */
export const updateAction = (id, action) => {
  return authAxios().put(`/v2/consumer-loans/${id}/${action}`)
}
